import { RowWrapper, SearchFilterWrapper } from "../types";
import { FilterType } from "./filters";

export function descendingComparator(
  a: RowWrapper<any>,
  b: RowWrapper<any>,
  orderBy: number
) {
  // icon content will result data to be an object, so we create a condition here. Otherwise, it will throw an error
  // since if data is an object, .toLocaleLowerCase won't work.
  let dataB = "";
  let dataA = "";
  if (typeof b.row.cells[orderBy]?.data !== "object") {
    dataB = b.row.cells[orderBy]?.data?.toLocaleLowerCase() || "";
    dataA = a.row.cells[orderBy]?.data?.toLocaleLowerCase() || "";
  }
  if (dataB < dataA) {
    return -1;
  }
  if (dataB > dataA) {
    return 1;
  }
  return 0;
}

export function stableSort(
  array: RowWrapper<any>[],
  order: Order,
  sortBy: number
) {
  if (order === "desc") {
    return array.sort((a, b) => descendingComparator(a, b, sortBy));
  } else {
    return array.sort((a, b) => -descendingComparator(a, b, sortBy));
  }
}

export const searchFilter = (
  rows: RowWrapper<any>[],
  searchFilterWrapper: SearchFilterWrapper
): RowWrapper<any>[] => {
  if (!!searchFilterWrapper.criteriSearch) {
    let cellIndexs = getIndexHeaderFromColumnToSearch(searchFilterWrapper);

    return rows.filter((row) => {
      for (var i = 0; i < cellIndexs.length; i++) {
        const cell = row.row.cells[cellIndexs[i]];

        if (
          !!cell &&
          !!cell.data &&
          cell.data
            .toLowerCase()
            .includes(searchFilterWrapper.criteriSearch.toLowerCase())
        ) {
          return true;
        }
      }

      return false;
    });
  } else {
    return rows;
  }
};

export const getIndexHeaderFromColumnToSearch = (
  searchFilterWrapper: SearchFilterWrapper
): number[] => {
  let map = new Map();
  searchFilterWrapper.headers.forEach((value, index) => {
    map.set(value, index);
  });
  let cellIndexs: number[] = [];
  searchFilterWrapper.columnToSearch.forEach((value: string) => {
    cellIndexs.push(map.get(value));
  });
  return cellIndexs;
};

export const paginateFilter = (
  rows: RowWrapper<any>[],
  page: number,
  rowsPerPage: number,
  order: string,
  orderBy: number
): RowWrapper<any>[] => {
  if (rows.length !== 0) {
    if (order === "desc") {
      rows = rows.sort((a, b) => descendingComparator(a, b, orderBy));
    } else {
      rows = rows.sort((a, b) => -descendingComparator(a, b, orderBy));
    }
  }

  return rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
};

export const applyFilters = (
  { rows, order, orderBy, searchFilterWrapper, page, rowsPerPage }: any,
  filters: FilterType[]
): RowWrapper<any>[] => {
  let aux: RowWrapper<any>[] = rows;
  for (const filter of filters) {
    switch (filter) {
      case FilterType.SORT:
        aux = stableSort(aux, order, orderBy);
        break;
      case FilterType.SEARCH:
        aux = searchFilter(aux, searchFilterWrapper);
        break;
    }
  }
  return aux;
};

export type Order = "asc" | "desc";
